import {
  OrderItem as OI,
  OrderingCategory,
  OrderingModifier
} from 'kiolyn-api';
import { isNullOrUndefined } from 'util';
import { isRequiredSelectionLevel } from '../models/SelectionLevel';
import { isEmpty } from 'lodash';

export default function loadOrderItemSelectableModifiers(
  orderItem: OI,
  categories: OrderingCategory[],
  modifiers: OrderingModifier[]
): OrderingModifier[] {
  // Find the matching category of the editting order item
  const category = categories.find(c => c.id === orderItem.categoryid);
  if (isNullOrUndefined(category) || isNullOrUndefined(category.items)) {
    return [];
  }
  // Find the matching item of the editting order item
  const item = category.items.find(i => i.id === orderItem.itemid);
  if (isNullOrUndefined(item) || isNullOrUndefined(item.modifiers)) {
    return [];
  }

  // Fetch modifiers detail from list of all modifiers
  const orderItemModifiers: (
    | OrderingModifier
    | undefined
  )[] = item.modifiers.map(itemModifier => {
    const modifier = modifiers.find(m => m.id === itemModifier.id);
    if (isNullOrUndefined(modifier)) {
      return undefined;
    }
    let itemModOptions = itemModifier.options || [];

    // Default to use the full list of options
    let options = modifier.options || [];
    // But if there is limitation on the list of options
    // then we must only take the available options
    if (!isEmpty(itemModOptions)) {
      options = options.filter(opt => itemModOptions.includes(opt.id));
    }

    return {
      id: itemModifier.id,
      name: modifier.name,
      prefix: modifier.prefix,
      selection_level: itemModifier.selection_level,
      options
    } as OrderingModifier;
  });
  // Filter out the not found modifier or modifier with empty options
  // this can happen if there is inconsitent data in which item contains modifier
  // that was somehow deleted
  const nonEmptyOrderItemModifiers: OrderingModifier[] = orderItemModifiers.filter(
    modifier => !isNullOrUndefined(modifier)
  ) as OrderingModifier[];
  return nonEmptyOrderItemModifiers.sort(compareBySelectionLevel);
}

function compareBySelectionLevel(
  m1: OrderingModifier,
  m2: OrderingModifier
): number {
  let m1V = 0;
  let m2V = 0;
  if (
    !isNullOrUndefined(m1.selection_level) &&
    isRequiredSelectionLevel(m1.selection_level)
  ) {
    m1V = 1;
  }
  if (
    !isNullOrUndefined(m2.selection_level) &&
    isRequiredSelectionLevel(m2.selection_level)
  ) {
    m2V = 1;
  }
  return m2V - m1V;
}
